import { useState } from "react";
import { Card, Col, Row, Table } from "react-bootstrap";
import { useSelector } from "react-redux";
import { Translate } from "../../../../Enums/Tranlate";
import MonthDropDown, { months } from "../../../../Enums/MonthDropDown";
import YearDropDown from "../../../../Enums/YearDropDown";
import SalarySlipService from "../../../../../services/HRM/SalarySlipService";
import EmployeesService from "../../../../../services/HRM/EmployeesService";
import ScrollPagination from "../../../../common/ScrollPagination";
import Loader from "../../../../common/Loader";
import NoData from "../../../../common/NoData";
import Pagination from "../../../../common/Pagination/Pagination";

const SalarySlip = () => {
	const lang = useSelector((state) => state.auth?.lang);
	const [data, setData] = useState([]);
	const [hasData, setHasData] = useState(null);
	const [loading, setLoading] = useState(false);
	const [shouldUpdate, setShouldUpdate] = useState(false);
	const [employee, setEmployee] = useState(null);
	const [params, setParams] = useState({
		month: {
			label: Translate[lang][months[new Date().getMonth()].toLocaleLowerCase()],
			value: months[new Date().getMonth()],
		},
		year: {
			label: `${new Date().getFullYear()}`,
			value: new Date().getFullYear(),
		},
	});

	const changeParams = (e, name) => {
		setParams((prev) => ({ ...prev, [name]: e }));
		setShouldUpdate((prev) => !prev);
	};

	const param = {
		month: months.indexOf(params.month?.value) + 1,
		year: params.year?.value,
		...(employee ? { employeeId: employee.value } : {}),
	};

	return (
		<>
			<Card className="mb-3">
				<Card.Body className="p-3">
					<Row className="align-items-end g-3">
						<Col md={5} sm={12}>
							<label className="text-label">{Translate[lang]?.employee}</label>
							<ScrollPagination
								Service={new EmployeesService()}
								value={employee}
								nameVal="name"
								setData={(e) => {
									setEmployee(e);
									setShouldUpdate((prev) => !prev);
								}}
							/>
						</Col>
						<Col md={3} sm={6}>
							<MonthDropDown params={params} changeParams={changeParams} />
						</Col>
						<Col md={3} sm={6}>
							<YearDropDown params={params} changeParams={changeParams} />
						</Col>
					</Row>
				</Card.Body>
			</Card>

			<Card>
				<Card.Body className={`${hasData === 0 && "text-center"}`}>
					{loading && (
						<div style={{ height: "300px" }}>
							<Loader />
						</div>
					)}
					{hasData === 1 && !loading && (
						<Table responsive>
							<thead>
								<tr className="text-center">
									<th>
										<strong>I.D</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.name}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.branch}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.department}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.job_title}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.type}</strong>
									</th>
									<th>
										<strong>{Translate[lang]?.deduction}</strong>
									</th>
								</tr>
							</thead>
							<tbody className="table-body">
								{data?.map((item, index) => (
									<tr key={item.id || index} className="text-center">
										<td>
											<strong>{item.employeeId}</strong>
										</td>
										<td>{item.employeeName || "-"}</td>
										<td>{item.branch || "-"}</td>
										<td>{item.department || "-"} </td>
										<td>{item.jobTitle || "-"} </td>
										<td>{item.type || "-"} </td>
										<td>
											<strong>
												{item.deductionAmount || "-"} {Translate[lang]?.kwd}
											</strong>
										</td>
									</tr>
								))}
							</tbody>
						</Table>
					)}
					{hasData === 0 && <NoData />}
					<Pagination
						setData={setData}
						service={new SalarySlipService()}
						shouldUpdate={shouldUpdate}
						setHasData={setHasData}
						setLoading={setLoading}
						param={param}
					/>
				</Card.Body>
			</Card>
		</>
	);
};

export default SalarySlip;
